import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
    size?: "sm" | "md" | "lg";
    className?: string;
}

export function LoadingSpinner( { size = "md", className }: LoadingSpinnerProps ) {
    const sizeClasses = { sm: "w-4 h-4 border-[2px]", md: "w-6 h-6 border-[3px]", lg: "w-8 h-8 border-[4px]" };

    return (
        <div
            className={cn(
                "inline-block rounded-full border-solid border-stroke-muted border-t-action-primary animate-spin",
                sizeClasses[size],
                className,
            )}
            role="status"
            aria-label="Loading"
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
}
